function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderSpaceDeleteApi, folderSpaceListApi, folderTotalApi, folderMatchtListApi as _folderMatchtListApi } from '@/api/cloud';
import debounce from '@form-create/utils/lib/debounce';
import countTo from 'vue-count-to';
export default {
  name: 'CloudfileLeft',
  components: {
    spaceDialog: function spaceDialog() {
      return import('../spaceDialog');
    },
    countTo: countTo
  },
  data: function data() {
    return {
      showComBtn: true,
      showEntBtn: true,
      fromData: {},
      tableFrom: {
        id: '',
        selectIndex: 6,
        keyword: '',
        type: 1
      },
      isAcitive: false,
      searchFlag: false,
      searchList: [],
      shareArray: [{
        name: '最近浏览',
        type: 1,
        icon: 'iconzuijin'
      } //最近访问
      // { name: this.$t('file.collection'), type: 2, icon: 'iconshoucang1', number: 0 }, //收藏
      // { name: this.$t('file.share'), type: 3, icon: 'iconchangyongwenjianjia', number: 0 } //分享
      ],
      commonlyArray: [{
        name: this.$t('file.myfiles'),
        type: 4,
        icon: 'iconquanbuwendang'
      },
      //我的文件
      {
        name: this.$t('file.commonfolders'),
        type: 5,
        icon: 'iconchangyongwenjianjia'
      } //常用文件夹
      ],
      recoveryArray: [{
        name: this.$t('file.recyclebin'),
        type: 7,
        icon: 'iconhuishouzhan'
      }],
      fileSortData: [{
        name: this.$t('file.filename'),
        id: 1
      },
      //文件名
      {
        name: this.$t('file.creationtime'),
        id: 2
      },
      //创建时间
      {
        name: this.$t('file.updatetime'),
        id: 3
      },
      //图片
      {
        name: this.$t('file.filesize'),
        id: 4
      },
      //大小
      {
        name: this.$t('file.deletetime'),
        id: 5
      },
      //删除时间
      {
        name: this.$t('file.order'),
        id: 6
      },
      //升序
      {
        name: this.$t('file.desc'),
        id: 7
      } //降序
      ],
      shareIndex: 0,
      entIndex: 'recently',
      comIndex: null,
      recIndex: null,
      entArray: [],
      activeValue: '',
      spaceId: 0
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  mounted: function mounted() {
    this.getEntList();
    this.confirmData('recently');
  },
  methods: {
    setOptions: function setOptions() {
      this.shareArray = [{
        name: this.$t('file.lately'),
        type: 1,
        icon: 'iconzuijin'
      },
      //最近访问
      {
        name: this.$t('file.collection'),
        type: 2,
        icon: 'iconshoucang1',
        number: 0
      },
      //收藏
      {
        name: this.$t('file.share'),
        type: 3,
        icon: 'iconchangyongwenjianjia',
        number: 0
      } //分享
      ];
      this.commonlyArray = [{
        name: this.$t('file.myfiles'),
        type: 4,
        icon: 'iconquanbuwendang'
      },
      //我的文件
      {
        name: this.$t('file.commonfolders'),
        type: 5,
        icon: 'iconchangyongwenjianjia'
      } //常用文件夹
      ];
      this.recoveryArray = [{
        name: this.$t('file.recyclebin'),
        type: 7,
        icon: 'iconhuishouzhan'
      }]; //回收站文件
      this.getFolderTotal();
    },
    // 展示常用文件夹和我的文件
    showCommonly: function showCommonly() {
      this.showComBtn === false ? this.showComBtn = true : this.showComBtn = false;
    },
    // 展开企业空间
    showEnt: function showEnt() {
      this.showEntBtn === false ? this.showEntBtn = true : this.showEntBtn = false;
    },
    //确定是否提交
    confirmData: function confirmData(data) {
      this.$emit('confirmData', this.tableFrom, data);
    },
    recoveryFn: function recoveryFn() {
      this.tableFrom.selectIndex = 7;
      this.confirmData('recovery');
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.tableFrom.type = 2;
      this.confirmData();
    },
    // 点击企业空间
    entClick: function entClick(index, id, item) {
      this.shareIndex = null;
      this.comIndex = null;
      this.recIndex = null;
      this.tableFrom.selectIndex = 6;
      this.tableFrom.type = 1;
      this.tableFrom.id = id;
      this.confirmData(item);
      this.entIndex = index;
    },
    getEntList: function getEntList() {
      var _this = this;
      folderSpaceListApi().then(function (res) {
        _this.entArray = res.data;
        if (_this.entArray.length > 0) {
          _this.entClick('recently', 0, 'recently');
        } else {
          _this.tableFrom.id = '';
          _this.confirmData('recently');
        }
      });
    },
    //获取文件夹总数
    getFolderTotal: function getFolderTotal() {
      var _this2 = this;
      folderTotalApi().then(function (res) {
        _this2.shareArray[1].number = res.data.collect;
        _this2.shareArray[2].number = res.data.share;
      });
    },
    // 展示回收站文件
    clickRecovery: function clickRecovery(index, type) {
      this.shareIndex = null;
      this.entIndex = null;
      this.comIndex = null;
      this.tableFrom.selectIndex = type;
      this.tableFrom.type = 1;
      this.tableFrom.id = 0;
      this.confirmData();
      this.recIndex = index;
    },
    // 鼠标悬浮
    mouseOver: function mouseOver(index) {
      this.isAcitive = index;
    },
    // 防抖input
    inputChange: debounce(function () {
      // this.searchFlag = true;
      // this.folderMatchtListApi();
    }, 1500),
    folderMatchtListApi: function folderMatchtListApi() {
      var _this3 = this;
      var data = {
        keyword: this.tableFrom.keyword
      };
      _folderMatchtListApi(this.tableFrom.id, data).then(function (res) {
        _this3.searchList = res.data;
        _this3.searchList.map(function (item) {
          item.name = _this3.discolorationKeyword(item.name);
        });
      });
    },
    // 关键字变色
    discolorationKeyword: function discolorationKeyword(val) {
      var keyword = this.tableFrom.keyword;
      if (val.indexOf(keyword) > -1) {
        return val.replace(keyword, "<span style=\"color:#1890ff;\">".concat(keyword, "</span>"));
      } else {
        return val;
      }
    },
    addName: function addName() {
      this.fromData = {
        title: this.$t('file.spacesettings'),
        name: this.$t('setting.edit.selectmembers1'),
        edit: 1
      };
      this.$refs.spaceDialog.dialogVisible = true;
    },
    // 编辑窗口显示
    handleShow: function handleShow(value) {
      this.activeValue = value;
    },
    // 编辑窗口隐藏
    handleHide: function handleHide() {
      this.activeValue = '';
    },
    // 修改分类
    addEdit: function addEdit(item) {
      this.fromData = {
        title: "\u7A7A\u95F4".concat(this.$store.state.user.userInfo.uid === item.uid ? '编辑' : '查看'),
        name: this.$t('setting.edit.selectmembers1'),
        edit: 2,
        data: item
      };
      this.$refs.spaceDialog.dialogVisible = true;
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.$modalSure(_this4.$t('file.placeholder02'));
            case 2:
              _context.next = 4;
              return folderSpaceDeleteApi(item.id);
            case 4:
              _this4.getEntList();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};